<template>
    <div class="center_data_box">
        <!-- 标题 -->
        <center-title>{{$t("message.cdata.title")}}</center-title>
        <!-- 表单 -->
        <div class="center_data_form_box">
            <!-- 个人 -->
            <data-personal-form
                v-if="power.length && power.indexOf(111)>=0">
            </data-personal-form>
            <!-- 公司 -->
            <data-company-form
                v-else>
            </data-company-form>
        </div>
        <!-- 模态框 -->
        <data-dialog></data-dialog>
    </div>
</template>

<script>
import { mapState, mapActions } from "vuex";

export default {
    computed: mapState({
        power: state => state.user.power,
    }),
    components: {
        centerTitle: () => import("@/components/center/centerTitle"),
        dataCompanyForm: () => import("@/components/center/dataCompanyForm"),
        dataPersonalForm: () => import("@/components/center/dataPersonalForm"),
        dataDialog: () => import("@/components/center/dataDialog"),
    },
    methods: {
        ...mapActions([
            "getCompanyData",
            "getPersonalData"
        ])
    },
    beforeRouteEnter (to, from, next) {
        // ...
        next(vm => {
			setTimeout(() => {
				if(vm.power.includes(111)){
				    vm.getPersonalData();
				}else if(vm.power.includes(0)){
				    vm.getCompanyData();
				}else{
				    vm.$router.back();
				    return false;
				}
			}, 500)
        })
    }
}
</script>

<style scoped>
.center_data_form_box{
    padding: 20px;
    background: #fff;
}
</style>
